import { Component, OnInit } from '@angular/core';
import { InternationalPaymentService } from './international-payment.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonSubProductsHeroComponent } from 'src/app/shared/components/sub-products/sub-products-hero/hero.component';
import { CommonSubProductsAlternateBlocksComponent } from 'src/app/shared/components/sub-products/alternate-blocks/alternate-blocks.component';
import { CommonSubProductsVideoComponent } from 'src/app/shared/components/sub-products/video-section/video.component';
import { CommonSubProductsCustomerStoryComponent } from 'src/app/shared/components/sub-products/customer-story/customer-story.component';
import { CommonSubProductsDiscoverDifferenceComponent } from 'src/app/shared/components/sub-products/discover-difference/discover-difference.component';
import { CommonSubProductsPricingComponent } from 'src/app/shared/components/sub-products/pricing/pricing.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';

@Component({
  selector: 'app-international-payment',
  templateUrl: './international-payment.component.html',
  styleUrls: ['./international-payment.component.scss'],
  imports: [
    CommonSubProductsHeroComponent,
    CommonSubProductsAlternateBlocksComponent,
    CommonSubProductsVideoComponent,
    CommonSubProductsCustomerStoryComponent,
    CommonSubProductsDiscoverDifferenceComponent,
    CommonSubProductsPricingComponent,
    CommonSubProductsWhitePaperComponent,
    CommonGetstartedComponent,
  ],
})
export class InternatiionalPaymentsComponent implements OnInit {
  heroHeader:any;
  logosData:any;
  featureData1:any;
  featureData2:any;
  videoData:any;
  storyData:any;
  differenceData:any;
  pricingData:any;
  getStartedData:any;
  whitePaperData:any;
  constructor(
    private internationalPaymentService: InternationalPaymentService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthogService: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.internationalPaymentService.getinterntionalPaymentsPageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo'][0].fields;
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Business Account';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.psHeroPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);

    // fetch Hero Data
    this.internationalPaymentService.interntionalPaymentsHero$.subscribe(
      data => {
        if (data != null) {
          this.heroHeader = {
            tagIcon: data?.tags[0]?.fields?.icon?.fields?.file?.url,
            iconTitle: data?.tags[0]?.fields?.icon?.fields?.title,
            tagName: data.tags[0].fields.tagText,
            header: data.title,
            image: data.image[0].fields.file.url,
            alt: data.image[0].fields.title,
            paragraph: data.content,
            button1: {
              text: data?.buttons?.[0]?.fields.buttonText,
              url: data?.buttons?.[0]?.fields.redirectLink,
              target: data?.buttons?.[0]?.fields.actionType,
            },
            button2: {
              text: data?.buttons?.[1]?.fields.buttonText,
              url: data?.buttons?.[1]?.fields.redirectLink,
              target: data?.buttons?.[1]?.fields.actionType,
            },
          };
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsFeaturePanel1$.subscribe(
      data => {
        if (data != null) {
          this.featureData1 = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsFeaturePanel2$.subscribe(
      data => {
        if (data != null) {
          this.featureData2 = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsVideoPanel$.subscribe(
      data => {
        if (data != null) {
          this.videoData = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsCustomerStoryPanel$.subscribe(
      data => {
        if (data != null) {
          this.storyData = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsDiscoverDifferencePanel$.subscribe(
      data => {
        if (data != null) {
          this.differenceData = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsPricingPanel$.subscribe(
      data => {
        if (data != null) {
          this.pricingData = data;
        }
      }
    );
    this.internationalPaymentService.interntionalPaymentsWhitePaperPanel$.subscribe(
      data => {
        if (data != null) {
          this.whitePaperData = data;
        }
      }
    );
    this.internationalPaymentService.getStarted$.subscribe(data => {
      if (data != null) {
        this.getStartedData = {
          header: data.title,
          button1: {
            url: data?.buttons?.[0]?.fields.redirectLink,
            text: data?.buttons?.[0]?.fields.buttonText,
            target: data?.buttons?.[0]?.fields.actionType,
          },
          button2: {
            url: data?.buttons?.[1]?.fields.redirectLink,
            text: data?.buttons?.[1]?.fields.buttonText,
            target: data?.buttons?.[1]?.fields.actionType,
          },
        };
      }
    });
    this.posthogService.capturePageViewEvent('international_payments');
  }
}
